// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2aiEq","Logo":"Toolbar_Logo__kc0qB","DesktopOnly":"Toolbar_DesktopOnly__L6RMu"};